export const DEFAULT_SITE_URL = "https://daporkoe.com";
export const SITE_NAME = "Teras Alami";
export const SITE_TAGLINE = "Herbal & Wellness";
// Version cache buster untuk memaksa WhatsApp/scraper refresh og:image
export const OG_IMAGE_VERSION = "v=3";
export const DEFAULT_OG_IMAGE = `/images/og-share.jpg?${OG_IMAGE_VERSION}`;
export const DEFAULT_LOGO_IMAGE = "/images/teras-alami-logo.png";
export const CONTACT_CONFIG = {
  whatsappDisplay: "085878079442",
  whatsappUrl: "https://wa.me/6285878079442",
  operationalDays: "Setiap Hari",
  operationalHours: "08.00 - 17.00 WIB",
};

// Konfigurasi toko untuk label pengiriman (cetak pesanan)
// Sesuaikan dengan alamat & nomor HP toko yang benar
export const STORE_LABEL_CONFIG = {
  storeName: "Teras Alami",
  storeAddress: "Kota Kediri, Jawa Timur 64112",
  storePhone: "085878079442",
};

export const getSiteUrl = () => {
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_SITE_URL
  ) {
    return process.env.REACT_APP_SITE_URL.replace(/\/+$/, "");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, "");
  }

  return DEFAULT_SITE_URL;
};

export const toAbsoluteUrl = (path = "/") => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const base = getSiteUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

export const normalizePath = (path = "/") => {
  if (!path || path === "/") {
    return "/";
  }

  return path.startsWith("/") ? path : `/${path}`;
};

export const absoluteRouteUrl = (path = "/") => {
  return toAbsoluteUrl(normalizePath(path));
};
